import * as React from "react";
import {RouteComponentProps, Redirect} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {indexPath, routePaths} from "egold/routes";
import {IEgoldUserDetails, IGoldProductDetails, IRedeemGoldDetails} from "StateInterface";
import {useEffect} from "react";
import {clearPaymentLink, getPaymentLink} from "egold/actions";
import {vendor} from "egold/egold-config";
import {insideHeader, removeCountryCode} from "egold/utils";
import {getIdToken} from "service.tsx";
import {notifyAndroid, setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
interface IConnectProps {
    dispatch?: (action: any) => void;
    eGoldUserDetails: IEgoldUserDetails;
    productIndex: number;
    products: IGoldProductDetails[];
    paymentLink: string;
    apiVersion: number;
    redeemGoldDetails: IRedeemGoldDetails;
    isAndroid: boolean;
}
function ConfirmDelivery(props: IConnectProps & RouteComponentProps) {
    useEffect(() => {
        if (props.paymentLink) {
            if (props.isAndroid) {
                setAndroidTokenAndVersionBeforeRedirecting(props.apiVersion, getIdToken());
            }
            window.location.replace(props.paymentLink);
        }
        return () => componentUnmount();
    }, [props.paymentLink]);

    function componentUnmount() {
        if (props.isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: true, title: "Payment"});
        }
        props.dispatch(clearPaymentLink());
    }
    const handleProceed = () => {
        const paymentDetails = {
            mobile: removeCountryCode(String(props.eGoldUserDetails.mobile)),
            email: props.eGoldUserDetails.email,
            amount: Number(props.redeemGoldDetails.price),
            user_id: String(props.eGoldUserDetails.user_id),
            txn_id: String(props.redeemGoldDetails.txn_id),
            vendor_id: String(props.eGoldUserDetails.vendor_id),
            txn_type: "DELIVER",
            vendor: vendor.SAFEGOLD,
            name: "Delivery Gold User",
        };
        props.dispatch(getPaymentLink(paymentDetails));
    };
    function renderProceed() {
        return(
            <button className="mt-4 mb-2 eGold-submit-btn" onClick = {() => handleProceed()}>
                Make Payment
            </button>
        );
    }
    if (props.productIndex === null || props.productIndex === undefined) {
        return <Redirect to={`${indexPath}${routePaths.DELIVERY}`}/>;
    }
    return (
        <div className="confirm-container mx-2">
            {
                props.redeemGoldDetails ?
                    <div>
                        {insideHeader("Confirm Payment", props.history.goBack)}
                        <div className="text-center">
                        </div>
                        {renderDetails(props.products, props.productIndex, props.redeemGoldDetails)}
                        {renderProceed()}
                    </div> :
                    <div className="border p-5">Sorry. Something went wrong !</div>
            }
        </div>
    );
}

function renderDetails(products: IGoldProductDetails, index: number, redeem: IRedeemGoldDetails) {
    return(
        <div className="table-border p-2 mt-4">
            <table className="table table-borderless table-sm" style={{fontSize: "14px"}}>
                <tbody>
                <tr>
                    <td>Product</td>
                    <td className="text-right">{products[index].description}</td>
                </tr>
                <tr>
                    <td>Purity</td>
                    <td className="text-right">99.5%</td>
                </tr>
                <tr>
                    <td>Date</td>
                    <td className="text-right">{new Date().toDateString()}</td>
                </tr>
                <tr>
                    <td>Making Charges</td>
                    <td className="text-right">
                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                        {Number(redeem.price).toFixed(2)}
                    </td>
                </tr>
                <tr>
                    <td>Estimated Delivery Time</td>
                    <td className="text-right">
                        {redeem.estimated_delivery_days}
                    </td>
                </tr>
                <tr className="pt-3 border-top">
                    <th>Total Payable Amount</th>
                    <th className="text-right">
                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                        {Number(redeem.price).toFixed(2)}
                    </th>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        paymentLink: state.eGold.paymentLink,
        apiVersion: state.login.apiVersion,
        productIndex: state.eGold.selectedProductIndex,
        products: state.eGold.products,
        redeemGoldDetails: state.eGold.redeemGoldDetails,
        isAndroid: state.login.isAndroid,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(ConfirmDelivery);
